<template>
  <div>
    <Search id="web" />
    <reactive-list
      componentId="ResultCard"
      dataField="original_title"
      :size="8"
      loader="Loading Movies.."
      class="result-card-container"
      :showResultStats="false"
      :react="{ and: ['web'] }"
      :pagination="true"
    >
      <div slot="render" slot-scope="{ data }">
        <result-list-wrapper>
          <result-list v-bind:key="result._id" v-for="result in data">
            <result-list-image
              :small="true"
              :src="'https://image.tmdb.org/t/p/w500' + result.poster_path"
            />
            <result-list-content>
              <result-list-title>
                {{ result.original_title }}
              </result-list-title>
            </result-list-content>
          </result-list>
        </result-list-wrapper>
      </div>
    </reactive-list>
  </div>
</template>

<script>
import Search from "./Search";

export default {
  name: "Movies",
  components: {
    Search
  },
};
</script>